import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { VariantColorSelectorComponent } from './variant-color-selector.component';

@NgModule({
  declarations: [VariantColorSelectorComponent],
  imports: [CommonModule, RouterModule, UrlModule, I18nModule, MediaModule, MatTooltipModule],
  exports: [VariantColorSelectorComponent],
})
export class VariantColorSelectorModule {}
